import { DESIGN_STYLES } from "../../optics/components/drawers/settings/features/announcements/defaults";

const noYearFormat = {
  month: "short",
  day: "numeric",
};

const weekdayFormat = {
  weekday: "short",
  day: "numeric",
  month: "short",
};

const shortMonthFormat = {
  year: "numeric",
  month: "short",
  day: "numeric",
};

const numericMonthFormat = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

const dateFormatOptionsBasedOnStyle = {
  [DESIGN_STYLES.ANNOUNCEMENT]: shortMonthFormat,
  [DESIGN_STYLES.WEBINAR]: shortMonthFormat,
  [DESIGN_STYLES.TEAM_EVENT]: shortMonthFormat,
  [DESIGN_STYLES.NEWS]: shortMonthFormat,
  [DESIGN_STYLES.EVENT]: shortMonthFormat,
  [DESIGN_STYLES.SHORT_NEWS]: numericMonthFormat,

  [DESIGN_STYLES.BACKGROUND]: noYearFormat,
  [DESIGN_STYLES.CLASSIC]: weekdayFormat,
  [DESIGN_STYLES.IMAGE]: weekdayFormat,
  [DESIGN_STYLES.NOTIFICATION]: noYearFormat,
};

const getDateLocaleOptions = (designStyle) =>
  dateFormatOptionsBasedOnStyle[designStyle];

const getTimeLocaleOptions = (dateFormat) => ({
  hour12: dateFormat === "hh:mm A",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC",
});

export const buildDateAndSplit = (date, hasTime, locale, designStyle) => {
  if (!date) return {};

  const dateOptions = getDateLocaleOptions(designStyle);
  const dateKeys = Object.keys(dateOptions);

  const builtDate = {};
  dateKeys.forEach((key) => {
    const value = new Date(date).toLocaleString(locale, {
      [key]: dateOptions[key],
    });
    builtDate[key] = value;
  });
  return builtDate;
};

export const buildDate = (date, hasTime, locale, designStyle) => {
  if (!date) return "";

  const localeToUse = designStyle === DESIGN_STYLES.EVENT ? "en-US" : locale;

  const dateOptions = getDateLocaleOptions(designStyle);
  const dateString = new Date(date).toLocaleString(localeToUse, dateOptions);

  return dateString;
};

export const buildTime = (time, dateFormat, locale) => {
  if (!time) return "";

  const timeOptions = getTimeLocaleOptions(dateFormat);
  const timeString = new Date(`1970-01-01T${time}Z`).toLocaleTimeString(
    locale,
    timeOptions
  );

  return timeString;
};
